import { Component, EventEmitter, Input, Output } from '@angular/core';
import { EnvironmentService } from '../../services/environment.service';

@Component({
  selector: 'environment-switcher',
  templateUrl: './environment-switcher.component.html',
  styleUrls: ['./environment-switcher.component.sass']
})
export class EnvironmentSwitcherComponent {

  @Output() environmentChanged = new EventEmitter<string>();

  constructor(
    public environment: EnvironmentService ) { } 

  public getEnvButtonClass(btnRadio) {
    return 'btn ' + ((btnRadio === this.environment.environment) ? 'btn-info' : 'btn-light');
  }

  public onEnvChange(env) {
    this.environmentChanged.emit(env);   
  }
}
